import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateCitySingle = {
  citySingle: { data: null, loading: false, error: null },
};

export const citySingle = createAsyncThunk('user/citySingle', async ({ id }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/city/${id}`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCitySingle = {
  [citySingle.pending]: (state) => {
    state.citySingle.loading = true;
  },
  [citySingle.fulfilled]: (state, action) => {
    state.citySingle.loading = false;
    state.citySingle.data = action.payload;
    state.citySingle.error = null;
  },
  [citySingle.rejected]: (state, action) => {
    state.citySingle.data = null;
    state.citySingle.loading = false;
    state.citySingle.error = action.payload;
  },
};
